import React from "react";
import styles from "./cancellation_policy.module.css";
import classNames from "classnames";
interface CancellationPolicyData {
  title: string;
  info: string;
}

interface CancellationPolicyProps {
  html: string;
  variant?: "gray" | "default";
}

export function CancellationPolicy(props: CancellationPolicyProps) {
  const { html, variant = "default" } = props;
  const data = parseData(html);

  return (
    <div className="bs-general-info my-3 py-2">
      <h3>{data.title}</h3>

      <div
        className={classNames("row py-2 mx-1", {
          [styles.cancelText]: variant === "gray",
        })}
      >
        {data.info}
      </div>
    </div>
  );
}

function parseData(data: string): CancellationPolicyData {
  const el = document.createElement("div");
  el.innerHTML = data;
  const title =
    el.getElementsByTagName("h3")[0]?.innerText ||
    el.getElementsByTagName("h2")[0]?.innerText;
  const info = el.getElementsByTagName("p")[0]?.innerText;

  return {
    title: title || "Cancellation policy",
    info,
  };
}
